// export { SkeletonContainer } from './SkeletonContainer';

export { LoadableTextRowSkeleton } from './LoadableTextRowSkeleton';
export { ParagraphSkeleton } from './ParagraphSkeleton';
